import * as S from '../Styled';
import React from 'react';
import { useSelector } from 'react-redux';

const Success = () => {
  const autState = useSelector(state => state.auth);
  return (
    <S.Success>
      <S.Mark>
        <img src="/assets/images/mark.svg" alt="Подтверждение" />
      </S.Mark>
      <S.Message>{autState.data.message}</S.Message>
    </S.Success>
  );
};

export default Success;
